class StopViewCollection extends App.Collections.BaseCollection {
  url = "StopView";
  model = App.Models.StopView;

  getLengthRedeliverys = locationKey => {
    let totalRedelivery = 0;
    this.models.forEach(model => {
      const stop = model.get("stop");
      if (stop.redeliveryStop) {
        const location = stop.location;
        if (location && location.key === locationKey) {
          totalRedelivery++;
        }
      }
    });

    return totalRedelivery;
  };
}

App.Collections.StopViews = StopViewCollection;
